import Intersection from "./components/intersection";

const init = () => {
  new Intersection();
};

init();
